/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { Urls } from 'src/app/models/application-enum.model';
import { ProgressIndicatorService } from 'src/app/shared/progress-indicator/progress-indicator.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class SecurityInterceptorService implements HttpInterceptor {


  constructor(private _progressIndicatorService: ProgressIndicatorService, private _router: Router,) {
  }


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Access denied or forbidden
          this._router.navigateByUrl(Urls.accessDenied);
          this._progressIndicatorService.show(false);
        }
        return throwError(error);
      })
    );
  }
}
